import { ColDef, ColumnState, GridApi } from 'ag-grid-community'

export function getOrderedColumnsFromState<T extends { field?: string }>(
  savedState: string | null,
  baseColumns: T[],
  gridApiRef?: GridApi | null
): ColDef[] | undefined {
  if (!savedState) return undefined
  if (!gridApiRef) return undefined
  const state = JSON.parse(savedState)
  const orderedColumns: ColDef[] = []
  const usedFields = new Set<string>()

  state.forEach((colState: ColumnState) => {
    const col = baseColumns.find((c) => c.field === colState.colId)
    if (col) {
      const colCopy = { ...col }
      if ('width' in colCopy && colState.width !== undefined) {
        colCopy.width = colState.width
      }
      orderedColumns.push(colCopy)
      if (colCopy.field) usedFields.add(colCopy.field)
    }
  })

  baseColumns.forEach((col) => {
    if (col.field && !usedFields.has(col.field)) {
      orderedColumns.push(col)
    }
  })

  return orderedColumns
}

const PROGRAMMATIC_COLUMN_EVENT_SOURCES = new Set<string>([
  'api',
  'gridInitializing',
  'gridOptionsChanged',
  'rowModelUpdated',
  'rowDataUpdated',
])

export function isProgrammaticColumnEvent(source?: string): boolean {
  return !!source && PROGRAMMATIC_COLUMN_EVENT_SOURCES.has(source)
}
